"use client";

import { useState, useEffect } from "react";
import Image from "next/image";
import Link from "next/link";
import dynamic from "next/dynamic";
const ApplyForm = dynamic(() => import("./apply-form"), { ssr: true });
import { parseHtml } from "@/utils/common";
import styles from "./career-explore.module.scss";

interface CareerExploreProps {
  data?: any;
  listData: any[];
  isMobile?: boolean;
  handleSwitch: () => void;
}

const CareerExplore = ({
  data,
  listData,
  handleSwitch,
}: CareerExploreProps) => {
  const [job, setJob] = useState<any>({});
  const [search, setSearch] = useState("");
  const [requirements, setRequirements] = useState<any[]>([]);
  const [requirementsCopy, setRequirementsCopy] = useState<any[]>([]);
  const [selectedCity, setSelectedCity] = useState("Ahmedabad");

  // Modal
  const [isApplyModalOpen, setIsApplyModalOpen] = useState(false);
  useEffect(() => {
    if (isApplyModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isApplyModalOpen]);

  useEffect(() => {
    handleSwitch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCity]);

  // Accordion

  const [isPlanningOpen, setIsPlanningOpen] = useState(true);
  const [isStakeholderOpen, setIsStakeholderOpen] = useState(false);
  useEffect(() => {
    setRequirements(listData);
    setRequirementsCopy(listData);
  }, [listData]);
  const handleSearch = () => {
    const val = search.toLowerCase();
    const filteredData = requirements.filter(
      (item: any) =>
        item?.Location?.toLowerCase().includes(val) ||
        item?.position?.toLowerCase().includes(val) ||
        item?.Experience?.toLowerCase().includes(val),
    );
    setRequirementsCopy(filteredData);
  };
  const handleSearchChange = (e: any) => {
    const val = e.target.value;
    setSearch(val);
    if (!val) setRequirementsCopy(requirements);
  };

  const handleOpenApplyModal = (e: any, item?: any) => {
    e.preventDefault();
    if (item?.id) setJob(item);
    setIsApplyModalOpen(!isApplyModalOpen);
  };

  return (
    <>
      <section
        id="positions"
        className="relative z-[0] overflow-hidden py-[56px] lg:py-[80px] xl:py-[100px] bg-white"
      >
        <div className="container">
          <div
            className={`${styles.headingCareer} mb-[32px] lg:mb-[32px] xl:mb-[40px] `}
          >
            <h2 className="text-center font-bold text-primary-text text-heading-1 mb-[12px]">
              {data?.short_title}
            </h2>
            <p className="text-[#32343B] text-subtitle-3 text-center">
              {data?.title}
            </p>
          </div>
          {/* Switch */}
          <div
            className={`${styles.switchButtonMain} flex items-center mt-[60px] mb-[50px]  gap-[50px] justify-center`}
          >
            <span
              className={`xl:text-[16px] xl:leading-[22.4pxpx] text-[14px] leading-[19.6px] cursor-pointer transition-colors ${
                selectedCity === "Ahmedabad"
                  ? "text-[#040405] font-[700]"
                  : "text-[#83858C]"
              }`}
              onClick={() => setSelectedCity("Ahmedabad")}
            >
              Ahmedabad
            </span>

            <div
              className={`${styles.switchButton} relative w-[109px] h-[32px] bg-[#B0D9F7] rounded-full cursor-pointer transition-colors flex-shrink-0`}
              onClick={() =>
                setSelectedCity(
                  selectedCity === "Ahmedabad" ? "Surat" : "Ahmedabad",
                )
              }
            >
              <Image
                src="/images/career-switch.svg"
                alt="switch"
                width={76}
                height={76}
                className={` ${styles.switchButtonImg}  absolute top-[-20px] left-[-20px] rounded-[50%] flex-shrink-0  w-[76px] h-[76px] flex justify-center items-center  transform transition-transform ${
                  selectedCity === "Surat" ? "translate-x-[60px]" : ""
                }`}
              />
            </div>

            <span
              className={`xl:text-[16px] xl:leading-[22.4px] text-[14px] leading-[19.6px] cursor-pointer transition-colors ${
                selectedCity === "Surat"
                  ? "text-[#040405] font-[700]"
                  : "text-[#83858C]"
              }`}
              onClick={() => setSelectedCity("Surat")}
            >
              Surat
            </span>
          </div>
          {/* Search */}
          <div className="blog-search border-1 border-[#B0D9F7] bg-white p-[20px_12px] lg:p-[24px_12px] relative w-[100%] mb-[40px]">
            <Image
              src="/images/blog-search-icon.svg"
              alt="search icon"
              width={28}
              height={28}
              className="absolute top-1/2 left-[16px] -translate-y-1/2 xl:w-[28px] xl:h-[28px] w-[21px] h-[21px]"
            />

            <div className="flex items-center justify-center absolute top-1/2 right-[12px] -translate-y-1/2">
              <button
                type="button"
                onClick={handleSearch}
                aria-label="Contact us"
                className="flex items-center justify-center gap-2.5 font-semibold transition-all duration-300 group
                            bg-text-button hover:bg-blue-700 cursor-pointer text-primary-text-white
                            my-0 xl:text-subtitle-3 whitespace-nowrap lg:text-subtitle-4  text-subtitle-3 p-[12px_20px]"
              >
                Search
              </button>
            </div>

            <input
              type="text"
              value={search}
              placeholder="Search"
              onChange={handleSearchChange}
              className="border-none outline-none shadow-none text-[#040405] :placeholder:text-[#83858C] font-[400] text-[18px] leading-[25.2px] pl-[35px] md:pl-[50px] pr-[100px] md:pr-[120px] w-full"
            />
          </div>
          {/* Position */}
          <div className="apply-cards">
            {requirementsCopy
              .filter((item: any) => item?.Location.includes(selectedCity))
              // ?.slice((currentPage - 1) * 10, currentPage * 10)
              ?.map((item: any, index: number) => (
                <div
                  key={"apply" + index}
                  className="border-[#B0D9F7] border-b first:border-t p-[32px_0px]"
                >
                  <div className="grid grid-cols-1 md:grid-cols-[calc(70%_-_12px)_calc(30%_-_12px)] gap-[16px] lg:grid-cols-[calc(70%_-_12px)_calc(30%_-_12px)] lg:gap-[24px]">
                    <div>
                      <h6 className="text-[#040405] font-[700] xl:text-[32px] xl:leading-[41.6px] md:text-[24px] md:leading-[31.2px] text-[22px] leading-[28.6px] mb-[12px]">
                        {item?.position}
                      </h6>
                      <div className="flex gap-[12px] flex-wrap">
                        <div className="border border-[#B0D9F7] md:p-[10px_12px] p-[8px_10px]">
                          <span className="text-center text-[#32343B] xl:text-[14px] xl:leading-[19.6px] text-[12px] leading-[16.8px] font-[400]">
                            {item?.Location}
                          </span>
                        </div>
                        <div className="border border-[#B0D9F7] md:p-[10px_12px] p-[8px_10px]">
                          <span className="text-center text-[#32343B] xl:text-[14px] xl:leading-[19.6px] text-[12px] leading-[16.8px] font-[400]">
                            {item?.Experience ?? "No"} Experience
                          </span>
                        </div>
                        <div className="border border-[#B0D9F7] md:p-[10px_12px] p-[8px_10px]">
                          <span className="text-center text-[#32343B] xl:text-[14px] xl:leading-[19.6px] text-[12px] leading-[16.8px] font-[400]">
                            Openings:{item?.no_of_positions ?? "0"}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-start md:justify-end">
                      <Link
                        href="#"
                        onClick={(e) => handleOpenApplyModal(e, item)}
                        className="hover:bg-[#c5e7ff75] transition-all duration-300  border border-[#B0D9F7] text-[#32343B] xl:text-[18px] xl:leading-[25.2px] text-[16px] leading-[22.4px] font-[600] p-[10px_12px] h-fit flex items-center"
                      >
                        Apply
                        <Image
                          src="/images/career-apply-arrow.svg"
                          width={20}
                          height={20}
                          className="ml-[10px] md:ml-[16px] w-[20px] h-[20px] hidden md:block"
                          alt="arrow"
                        />
                        <Image
                          src="/images/career-apply-arrow2.svg"
                          width={20}
                          height={20}
                          className="ml-[10px] md:ml-[16px] w-[20px] h-[20px] md:hidden block"
                          alt="arrow"
                        />
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </section>

      {/* Modal Start*/}
      {isApplyModalOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
          onClick={handleOpenApplyModal} // overlay click closes modal
        >
          <div
            data-lenis-prevent
            className="pt-[0] xl:pt-[0] p-[20] xl:p-[40px] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white  w-[90%] max-w-[1020px] max-h-[90vh] flex flex-col overflow-auto"
            onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside modal
          >
            {/* Modal Header */}
            <div className="flex justify-between items-center py-[20px] xl:py-[32px] sticky top-0 bg-white z-[1] p-[10px]">
              <h2 className="text-[#040405] xl:text-[24px] xl:leading-[31.2px] text-[20px] leading-[26px] font-[600]">
                Applying For Job
              </h2>
              <button
                onClick={handleOpenApplyModal}
                className="border-0 cursor-pointer"
              >
                <Image
                  src="/images/career-close-icon.svg"
                  alt="next"
                  width={32}
                  height={32}
                  className="object-cover block xl:w-[32px] xl:h-[32px] w-[24px] h-[24px]"
                />
              </button>
            </div>

            {/* Body */}

            <div className="modal-body">
              {/* Banner */}
              <div className="relative z-[0] bg-[#E6F3FD] overflow-hidden  before:content-[''] before:absolute before:h-[100%] before:w-[100%] before:right[0] before:bottom-[0] before:bg-[url('/images/career-bg-shape-7.png')] before:bg-no-repeat before:bg-[length:100%_100%] before:bg-center before:bg-[#F0F8FF] before:-z-[2]">
                {/* Shape */}
                <div className="absolute right-[0] bottom-[0]">
                  <Image
                    src="/images/career-bg-shape-3.svg"
                    alt="promise shape"
                    width={191}
                    height={94}
                    className="object-cover w-auto h-auto"
                  />
                </div>
                <div className="absolute left-[0] top-[0] h-full">
                  <Image
                    src="/images/career-bg-shape-6.png"
                    alt="promise shape"
                    width={650}
                    height={355}
                    className="object-cover w-auto h-full"
                  />
                </div>

                {/* Dots */}
                <span className="absolute z-10 shadow-[0_3px_6px_0_#00000033] bg-white rounded-full w-[10px] h-[10px] top-[12px] left-[12px]"></span>
                <span className="absolute z-10 shadow-[0_3px_6px_0_#00000033] bg-white rounded-full w-[10px] h-[10px] top-[12px] right-[12px]"></span>
                <span className="absolute z-10 shadow-[0_3px_6px_0_#00000033] bg-white rounded-full w-[10px] h-[10px] bottom-[12px] left-[12px]"></span>
                <span className="absolute z-10 shadow-[0_3px_6px_0_#00000033] bg-white rounded-full w-[10px] h-[10px] bottom-[12px] right-[12px]"></span>

                {/* Content */}
                {job?.position && (
                  <div className=" md:p-[32px_24px] p-[32px_20px]  z-1 relative">
                    <h2 className=" xl:text-[40px] xl:leading-[52px] md:text-[36px] md:leading-[46.8px] text-[28px] leading-[36.4px] text-[#040405] pb-[12px] font-[700]">
                      {job?.position}
                    </h2>
                    <div className="flex gap-[12px] flex-wrap mb-[24px]">
                      <div className="md:p-[10px_12px] p-[10px_12px] bg-white">
                        <span className="text-center text-[#32343B] xl:text-[14px] xl:leading-[19.6px] text-[12px] leading-[16.8px] font-[400]">
                          {job?.Location}
                        </span>
                      </div>
                      <div className="md:p-[10px_12px] p-[10px_12px] bg-white">
                        <span className="text-center text-[#32343B] xl:text-[14px] xl:leading-[19.6px] text-[12px] leading-[16.8px] font-[400]">
                          Openings:{job?.no_of_positions ?? "0"}
                        </span>
                      </div>
                      <div className="md:p-[10px_12px] p-[10px_12px] bg-white">
                        <span className="text-center text-[#32343B] xl:text-[14px] xl:leading-[19.6px] text-[12px] leading-[16.8px] font-[400]">
                          {job?.Experience ?? "No"} Experience
                        </span>
                      </div>
                    </div>
                    <div
                      className={`xl:text-[16px] xl:leading-[22.4px] text-[14px] leading-[19.6px] text-[#040405] mb-[16px] font-[400] ${styles.accordionContent}`}
                    >
                      {parseHtml(job?.description)}
                    </div>
                  </div>
                )}
              </div>

              {/* Accordion */}
              {job?.position && (
                <div className="bg-white px-[20px] border border-[#B0D9F7] mb-[32px]">
                  <div>
                    {/* Responsibilities  */}
                    <div className="border-b border-[#B0D9F7]">
                      <button
                        onClick={() => setIsPlanningOpen(!isPlanningOpen)}
                        className="text-left font-[700] xl:text-[24px] xl:leading-[31.1px] text-[20px] leading-[26px] text-[#040405] cursor-pointer  py-[20px] w-full transition duration-300 ease-in-out flex items-center justify-between"
                      >
                        Responsibilities
                        <span className="ml-2 flex-shrink-0">
                          <Image
                            src={
                              isPlanningOpen
                                ? "/images/career-minus-icon.svg"
                                : "/images/career-plus-icon.svg"
                            }
                            alt={isPlanningOpen ? "Collapse" : "Expand"}
                            width={20}
                            height={20}
                          />
                        </span>
                      </button>
                      {isPlanningOpen && (
                        <div
                          className={`border-t border-[#B0D9F7] py-[24px] ${styles.accordionContent}`}
                        >
                          {parseHtml(job?.responsibilities)}
                        </div>
                      )}
                    </div>

                    {/* Required Experience */}
                    <div className="border-b border-[#B0D9F7] last:border-none">
                      <button
                        onClick={() => setIsStakeholderOpen(!isStakeholderOpen)}
                        className="text-left font-[700] xl:text-[24px] xl:leading-[31.1px] text-[20px] leading-[26px] text-[#040405] cursor-pointer  py-[20px] w-full transition duration-300 ease-in-out flex items-center justify-between"
                      >
                        Required Experience, Skills and Qualifications
                        <span className="ml-2 flex-shrink-0">
                          <Image
                            src={
                              isStakeholderOpen
                                ? "/images/career-minus-icon.svg"
                                : "/images/career-plus-icon.svg"
                            }
                            alt={isStakeholderOpen ? "Collapse" : "Expand"}
                            width={20}
                            height={20}
                          />
                        </span>
                      </button>
                      {isStakeholderOpen && (
                        <div
                          className={`border-t border-[#B0D9F7] py-[24px] ${styles.accordionContent}`}
                        >
                          {parseHtml(job?.required_skills)}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* Apply Form */}
              <ApplyForm data={requirements} job={job} />
            </div>
          </div>
        </div>
      )}
      {/* Modal End */}
    </>
  );
};
export default CareerExplore;
